import { TeamType } from 'src/types/domain.types';
import { Checkbox, TextField } from '@mui/material';
import { TeamIcon } from 'src/components/TeamIcon';

interface TeamListItemProps {
  team: TeamType;
  form: any;
  lang: any;
}

export const AnimatedTeamBox = ({ team, form, lang }: TeamListItemProps) => {
  const handleCheckboxChange = () => {
    team.team_win = !team.team_win;
    form.setFieldValue('teams', [...form.getFieldValue('teams')]);
  };

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '2fr 1fr 1fr 1fr',
        gap: '16px',
        alignItems: 'center',
        width: '100%',
      }}
    >
      {/* Team Name */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <TeamIcon {...team} />
        <span style={{ fontWeight: 600, fontSize: '14px' }}>
          {team[`name_${lang.code}` as keyof TeamType] ?? team.name_en}
        </span>
      </div>

      {/* Score Input */}
      <TextField
        variant='standard'
        label='Score'
        value={team.score}
        onChange={(e) => {
          const updatedTeam = { ...team, score: e.target.value };
          form.setFieldValue(
            'teams',
            form
              .getFieldValue('teams')
              .map((t: TeamType) =>
                t.team_id === team.team_id ? updatedTeam : t
              )
          );

          // set is_score to true if score is not empty
          form.setFieldValue('is_score', true);
        }}
      />

      {/* Odds Input */}
      <TextField
        variant='standard'
        label='Odds'
        value={team.team_odds}
        onChange={(e) => {
          const updatedTeam = { ...team, team_odds: e.target.value };
          form.setFieldValue(
            'teams',
            form
              .getFieldValue('teams')
              .map((t: TeamType) =>
                t.team_id === team.team_id ? updatedTeam : t
              )
          );
        }}
      />

      {/* Winner Checkbox */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Checkbox
          checked={team.team_win}
          onChange={handleCheckboxChange}
          style={{
            transform: 'scale(1.2)',
            accentColor: '#5286C6',
            cursor: 'pointer',
          }}
        />
        <label style={{ fontSize: '12px', cursor: 'pointer' }}>Winner</label>
      </div>
    </div>
  );
};
